import SystemCompanyInfoApi from '@/api/supplier/systemCompanyInfoApi.js'
import { normalizeSchemeCustomerItem } from '../adapters/index.js'

export async function fetchSchemeCustomerList(serviceId, raw = false) {
  if (!serviceId) return { rows: [], totalRows: 0, raw: null }

  const res = await SystemCompanyInfoApi.listRecommendByServiceId(serviceId)
  if (res?.code !== '00000') return { rows: [], totalRows: 0, raw: res }

  const rows = Array.isArray(res.rows) ? res.rows : []
  return {
    rows: raw ? rows : rows.map(normalizeSchemeCustomerItem).filter(Boolean),
    totalRows: res.totalRows || rows.length || 0,
    raw: res
  }
}
